import { ServiceYoutube } from '~publish/legacy/constants/services/ServiceDefinitions'

const YOUTUBE_TITLE_MAX_LENGTH = ServiceYoutube.titleCharLimit

export const getYoutubeTitleFromText = (text: string): string => {
  const firstLine = text.split(/\r?\n/u)[0] ?? ''

  if (YOUTUBE_TITLE_MAX_LENGTH === null) {
    return firstLine.trim()
  }

  return firstLine.trim().slice(0, YOUTUBE_TITLE_MAX_LENGTH)
}

export const shouldSyncYoutubeTitleWithText = ({
  currentTitle,
  lastSyncedTitle,
  previousText,
}: {
  currentTitle?: string | null
  lastSyncedTitle?: string
  previousText: string
}): boolean => {
  if (currentTitle == null) {
    return true
  }

  if (typeof lastSyncedTitle !== 'undefined') {
    return currentTitle === lastSyncedTitle
  }

  return (
    currentTitle === '' &&
    getYoutubeTitleFromText(previousText) === currentTitle
  )
}
